import { z } from "zod";
import { CAREER_KEY_TYPE, CERTIFICATES_KEY_TYPE } from "../common/enum";

export const registrationDateSchema = z.object({
	from: z.string().nullable(),
	to: z.string().nullable()
});

export type RegistrationDateType = z.infer<typeof registrationDateSchema>;

export const birthPlaceSchema = z.object({
	birthSiDo: z.string().optional().default(""),
	birthSiGunGu: z.string().optional().default("")
});

export type BirthPlaceType = z.infer<typeof birthPlaceSchema>;

export const detailSearchFormSchema = z.object({
	name: z.string().optional(),
	corporationName: z.string().optional(),
	jibunAddress: z.string().optional(),
	employeeIds: z.array(z.string()).optional().default([]),
	school: z.string().optional(),
	certificates: z.array(CERTIFICATES_KEY_TYPE).optional().default([]),
	careerTypes: z.array(CAREER_KEY_TYPE).optional().default([]),
	genderCodes: z.array(z.number()).optional().default([]),
	birthYear: z.string().nullable(),
	birthPlace: birthPlaceSchema,
	numberOfExam: z.string().optional().default(""),
	registrationYearRange: registrationDateSchema,
	multiFilter: z.string().optional().default(""),
	areaBlockId: z.number().optional(),
});

export type DetailSearchFormType = z.infer<typeof detailSearchFormSchema>;

export const detailSearchSchema = z.object({
	name: z.string().optional(),
	corporationName: z.string().optional(),
	jibunAddress: z.string().optional(),
	employeeIds: z.array(z.string()).optional(),
	school: z.string().optional(),
	certificates: z.array(CERTIFICATES_KEY_TYPE).optional(),
	careerTypes: z.array(CAREER_KEY_TYPE).optional(),
	genderCodes: z.array(z.number()).optional(),
	birthYear: z.string().nullable(),
	birthSiDo: z.string().optional(),
	birthSiGunGu: z.string().optional(),
	numberOfExam: z.string().optional(),
	registrationYearRange: registrationDateSchema.nullable(),
	multiFilter: z.string().optional(),
	areaBlockId: z.number().optional(),
});

export type DetailSearchType = z.infer<typeof detailSearchSchema>;